import React from 'react';
import { ValidationProps } from 'ui';
import { CodetableTranslation, configurationAlreadyExistsKey } from 'app/area/indicator-factors/constants';
import { ValidationError } from 'ui/common/validation-error/validation-error';
import { CodeActionType } from 'app/area/indicator-factors/item/types';

import styles from './codetable-item-messages.scss';

interface CodetableItemMessagesProps {
  actionType: CodeActionType;
  savingCodetableItem: boolean;
  shouldPrompt: boolean;
  validation: { [key: string]: ValidationProps };
  translation: CodetableTranslation;
}

export const CodetableItemMessages = ({
  actionType, savingCodetableItem, shouldPrompt, validation, translation
}: CodetableItemMessagesProps) => {

  const isDuplicating = actionType === CodeActionType.Duplicate;
  const showAlertInfo = !savingCodetableItem && !shouldPrompt;
  const showExistingConfigurationError = Object.keys(validation).some(key => key === configurationAlreadyExistsKey);

  return <div className={styles.container}>
    {showAlertInfo && isDuplicating && <div className={`${styles.alertInfo} mb-4`}>
      <p>{translation.duplicate_info_text}</p>
    </div>}

    {showExistingConfigurationError && <ValidationError
      title={translation.duplicate_error_text_title}
      subtitle={translation.duplicate_error_text_subtitle}
    />}
  </div>;
};
